import { render } from "./Propostas.vue?vue&type=template&id=46efdf0b&scoped=true"
import script from "./Propostas.vue?vue&type=script&lang=js"
export * from "./Propostas.vue?vue&type=script&lang=js"

import "./Propostas.vue?vue&type=style&index=0&id=46efdf0b&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46efdf0b"]])

export default __exports__